import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={14}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 14.5A1.5 1.5 0 0 0 1.5 16h11a1.5 1.5 0 0 0 1.5-1.5V6H0v8.5Zm10-6.125c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375v1.25a.376.376 0 0 1-.375.375h-1.25A.376.376 0 0 1 10 9.625v-1.25Zm0 4c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375v1.25a.376.376 0 0 1-.375.375h-1.25a.376.376 0 0 1-.375-.375v-1.25Zm-4-4C6 8.169 6.169 8 6.375 8h1.25c.206 0 .375.169.375.375v1.25a.376.376 0 0 1-.375.375h-1.25A.376.376 0 0 1 6 9.625v-1.25Zm0 4c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375v1.25a.376.376 0 0 1-.375.375h-1.25A.376.376 0 0 1 6 13.625v-1.25Zm-4-4C2 8.169 2.169 8 2.375 8h1.25c.206 0 .375.169.375.375v1.25a.376.376 0 0 1-.375.375h-1.25A.376.376 0 0 1 2 9.625v-1.25Zm0 4c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375v1.25a.376.376 0 0 1-.375.375h-1.25A.376.376 0 0 1 2 13.625v-1.25ZM12.5 2H11V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2H5V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2H1.5A1.5 1.5 0 0 0 0 3.5V5h14V3.5A1.5 1.5 0 0 0 12.5 2Z"
      fill="#1D1D1D"
      fillOpacity={0.6}
    />
  </svg>
);

export default SvgComponent;
